import React from 'react';
import movieTrendImg from '../media/movie_trend_data_lake.jpg';
import nintendo3dsImg from '../media/nintendo_3ds_sales_report.jpg';
import databricksImg from '../media/Databricks_Table.jpg';


const Projects = () =>{

    return (
        <section className="mb-6">
            <h2 className="mb-2 text-xl">Projects</h2>

            <div className="grid grid-cols-1">
                <div className="window">
                    <div className="title-bar-text text-lg">Reddit Fashion Trend Pipeline</div>

                    <div className="window-body p-3">
                        <p className="mb-4 text-sm">
                            Tool that collects outfit photos from the r/fashion subreddit, uses AI to identify clothing items, colors, and styles in each photo, and organizes that information so analysts can easily search and track fashion trends.
                        </p>
                        <img src={databricksImg} alt={`Screenshot of Project`}
                        className="w-full mb-3"/>
                        <p className="mb-4 text-sm">
                            Python, REST APIs, Databricks, Computer Vision
                        </p>

                        <div className="flex gap-2 mt-auto text-[#000080]">
                            <a href="https://github.com/iancdunn/Visual-Reddit-Fashion-Classifier">GitHub Repository</a>
                        </div>
                    </div>
                </div>

                <div className="window">
                    <div className="title-bar-text text-lg">Movie Trend Data Lake</div>

                    <div className="window-body p-3">
                        <p className="mb-4 text-sm">
                            System that automatically retrieves movie data daily and organizes it into a secure cloud storage vault for future analysis.
                        </p>
                        <img src={movieTrendImg} alt={`Screenshot of Project`}
                        className="w-full mb-3"/>
                        <p className="mb-4 text-sm">
                            Python, REST APIs, GitHub Actions, PyTest, AWS S3, Pandas
                        </p>

                        <div className="flex gap-2 mt-auto text-[#000080]">
                            <a href="https://github.com/iancdunn/Movie-Trend-Data-Lake">GitHub Repository</a>
                        </div>
                    </div>
                </div>

                <div className="window">
                    <div className="title-bar-text text-lg">eBay ETL Pipeline</div>

                    <div className="window-body p-3">
                        <p className="mb-4 text-sm">
                            Tool that scans eBay to help collectors see the true market value of items by automatically cleaning up messy data and removing "fake" or irrelevant price listings.
                        </p>
                        <img src={nintendo3dsImg} alt={`Screenshot of Project`}
                        className="w-full mb-3"/>
                        <p className="mb-4 text-sm">
                            Python, Selenium, Pandas
                        </p>

                        <div className="flex gap-2 mt-auto text-[#000080]">
                            <a href="https://github.com/iancdunn/eBay-ETL-Pipeline">GitHub Repository</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Projects;
